import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { useState } from "react";
import { ClientDatabase } from "../types/db_management_types"; 
import DatabaseActionsModal from "./DatabaseActionsModal";
import "../styles/DbManagementStyles.css"
import { setgroups } from "process";

interface props {
    DataList: ClientDatabase[] | null,
    selectedEnv: string,
    handleCopyDatabase: (group?: string) => void,
    onGroupSelected: (group: string) => void; 

}

function DatabasesTable({ DataList, selectedEnv, handleCopyDatabase, onGroupSelected }: props) {

    const formatted_data = DataList?.map(item => ({
        ...item
    }));

    const [ShowModal, setShowDatabaseOptionsModal] = useState<boolean>(false);
    const handleClose = () => { setShowDatabaseOptionsModal(false) };
    const [currentRowKey, setcurrentRowKey] = useState("");
    const [group, setGroup] = useState("");
    
    const ButtonsTemplate = (rowData: ClientDatabase, column: any) => {
        return (<div>
            <Button className='small-pr-button green-background' severity='info' onClick={() => ViewDatabaseActionsClick(rowData)}>Action</Button>
        </div>)
    };

    const ViewDatabaseActionsClick = (rowData: ClientDatabase) => {
        setcurrentRowKey(() => { return rowData.clientID.toString(); })
        setGroup(rowData.group);
        onGroupSelected(rowData.group);
        setShowDatabaseOptionsModal(() => { return true });
    }
      
    return (
        <>

            <div className="data-table-databases">
                <DataTable paginator rows={10} value={formatted_data} stripedRows  sortField="group" sortOrder={1} showGridlines >
                    <Column field='clientID' header='Client ID' ></Column>
                    <Column field='group' header='Client Number'></Column>
                    <Column field='groupDescription' header='Client Name' ></Column>
                    <Column field="ButtonsTemplate" header="Actions" style={{ width: "23em" }} body={ButtonsTemplate} />
                </DataTable>
            </div>
            {ShowModal && (
                <DatabaseActionsModal handleClose={handleClose} RowKey={currentRowKey} group={group} selectedEnv={selectedEnv} handleCopyDatabase={handleCopyDatabase} />
            )
            }

        </>
    )
}

export default DatabasesTable;